// extracted by mini-css-extract-plugin
module.exports = {"r":"_2Q5eF","sm":"_1dCfG"};